import { isEmpty } from 'lodash';
import { PersonalInfoPersonTypes } from '../features/personal-info/personal-info-models';

/**
 * TCSMMVP-1270
 *	When updating any person in the system, the member_guid of the person doing the update should be added to the request.
 * 	When a member/admin updates info about themself or a member in MyCPG/MAP, person_type should be Member
 * @param payloadToUpdate Object to update.
 * @param memberGuid Id of the person doing the update.
 * @param personType Type of the person been updated.
 */
export function completePersonType(
	payloadToUpdate: any,
	memberGuid: string,
	personType: PersonalInfoPersonTypes = PersonalInfoPersonTypes.Member,
) {
	const updatedPayload = payloadToUpdate;
	if (!isEmpty(updatedPayload)) {
		updatedPayload.member_guid = memberGuid;
		updatedPayload.person_type = personType;
	}
}
